export default __webpack_public_path__ + "static/alfred_search_app-bbf00bbb6b26f06b0ef9687891dfb67c.png";